import { Tooltip } from 'antd';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { Reaction } from 'api/conversations';
import { Button } from 'components/atoms/button';

const ReactionButton = styled(Button)`
  animation: reactionsIconBounce var(--animation-duration-slower)
    cubic-bezier(0.28, 0.84, 0.42, 1) forwards;
  border: none;
  border-radius: var(--border-radius-curved);
  box-shadow: none;
  padding: var(--spacing-02) var(--spacing-03);
  transition: transform 0.1s;

  &&:hover {
    background: transparent !important;
  }

  > span {
    transition: transform var(--animation-duration-medium) ease-in-out;
  }

  &:nth-child(2n) {
    animation-delay: var(--animation-duration-fast);
  }

  &:nth-child(3n) {
    animation-delay: var(--animation-duration-medium);
  }

  &:hover > span {
    transform: scale(1.8) translateY(-20%);
  }

  @keyframes reactionsIconBounce {
    0% {
      transform: translateY(0);
    }
    10% {
      transform: scale(1.1, 0.9) translateY(0);
    }
    30% {
      transform: scale(0.9, 1.05) translateY(-8px);
    }
    50% {
      transform: scale(1.05, 0.95) translateY(0);
    }
    60% {
      transform: scale(1) translateY(-2px);
    }
    to {
      transform: scale(1) translateY(0);
    }
  }
`;

export const ReactionsList: FC<{
  addButtonClassName?: string;
  attachTo?: HTMLElement | null;
  onAddReaction(reactionType: Reaction): void;
}> = ({ onAddReaction }) => {
  const intl = useIntl();
  const reactionsToRender = Object.keys(Reaction);

  return (
    <>
      {reactionsToRender.map((reaction) => (
        <Tooltip
          key={`add-reactions-${reaction}`}
          title={intl.formatMessage({
            id: `reactions.${reaction}`,
          })}
        >
          <ReactionButton
            aria-label={reaction}
            size="small"
            onClick={() => onAddReaction(reaction as Reaction)}
          >
            {Reaction[reaction]}
          </ReactionButton>
        </Tooltip>
      ))}
    </>
  );
};
